import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import {
  CivilEngineeringDisplayNames,
  ConnectionChangeDto,
  ConnectionChangeRequestTypeDisplayValues,
  ConnectionChangeRequestTypeEnum
} from '@bo-client/shared/models/connectionChange.dto';
import {
  AllAreaEnum,
  AreaDisplayName
} from '@bo-client/activation-management/shared/models/commissioningModel';
import { FieldConfigEnum } from '@bo-client/shared/constants/enums';
import { Observable } from 'rxjs';
import { ConnectionChangeRequestTypeConfig } from '@bo-client/shared/config.model';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { getCalendarWeek } from '@bo-client/nap/connection-change/connection-change-detail/calendar-week-option';

@Component({
  selector: 'app-order-request-wizard-data-summary',
  templateUrl: './order-request-wizard-data-summary.component.html',
  styleUrl: './order-request-wizard-data-summary.component.scss'
})
export class OrderRequestWizardDataSummaryComponent implements OnInit {
  @Input() data: ConnectionChangeDto;

  private dataShareService = inject(DataShareService);
  private destroyRef = inject(DestroyRef);

  config$: Observable<ConnectionChangeRequestTypeConfig>;

  ngOnInit() {
    this.config$ = this.dataShareService
      .getSingleTenantConfig$<ConnectionChangeRequestTypeConfig[]>(
        'connectionChangeRequest.connectionChangeRequestTypes'
      )
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(
          (config) =>
            ConnectionChangeRequestTypeConfig.getConnectionChangeRequestTypeConfig(
              this.data.area,
              this.data.connectionChangeRequestType,
              config
            ) || {}
        )
      );
  }

  readonly ConnectionChangeRequestTypeDisplayValues = ConnectionChangeRequestTypeDisplayValues;
  readonly AreaDisplayName = AreaDisplayName;
  readonly ConnectionChangeRequestTypeEnum = ConnectionChangeRequestTypeEnum;
  readonly CivilEngineeringDisplayNames = CivilEngineeringDisplayNames;
  readonly AllAreaEnum = AllAreaEnum;
  readonly FieldConfigEnum = FieldConfigEnum;
  protected readonly getCalendarWeek = getCalendarWeek;
}
